import styled from 'styled-components';
import { lighten } from 'polished';

import 'antd/lib/spin/style/index.css';

export const BreadcumbsContainer = styled.div`
margin: 0 auto 5px auto;
width: auto;
max-width: 1068px;
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-between;
div.voltar {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-right: 20px;
  padding-top: 2px;
  button {
    display: flex;
    align-items: center;
    flex-direction: row;
    border: none;
    background: none;
    color: #619b30;
    font-weight: bold;
  }
}
`;

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.headerInline {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    div.boxSearch {
      margin-left: 20px;
      form {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      label {
        width: 244.5px;
        height: 33.4px;
        padding: 0 10px;
        border-radius: 3px;
        box-shadow: inset 0px 1px 0px 0px #c7c7c794;
        border: solid 1px #c7c7c794;
        background: #ffffff;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      input {
        border: 0;
        color: #74a50a;
        margin: 0 0 0 5px;
        &::placeholder {
          color: #dedede;
        }
      }
      button {
        margin-left: 4px;
        height: 33px;
        padding: 0 20px;
        border-radius: 3.5px;
        background-color: ${props => (props.clean ? '#235f6e' : '#74a50a')};
        border: none;
        color: #fff;
        display: flex;
        align-items: center;
      }
      button.limparBusca {
        height: 34px;
        border-radius: 3.5px;
        background-color: #235f6e;
        border: none;
        color: #ffffff;
        margin-left: 20px;
      }
    }
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
  .botao-download {
    background-color: #74a50a !important;
  }
`;

export const BoxContentHeader = styled.div`
  padding: 10px 30px;
  display: flex;
  align-self: center;
  height: 30px;
  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 170px;
    svg {
      color: #dddbdb;
    }
    span.nomeArquivoHeader {
      /* border: 1px solid green; */
      /* width: 195px; */
      width: 302px;
      padding-left: 20px;
    }
    span.categoriaHeader {
      width: 90px;
    }
    span.dataHeader {
      margin-left: 110px;
      padding-left: 32px;
    }

    span {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      color: #727272;
    }
  }
`;

export const BoxList = styled.div`
  width: '100%';
  height: 70px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #235f6e;

  div.nomeArquivo {
    padding-left: 50px;
    width: 250px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    // border: 1px solid red;
    align-items: center;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.46px;
    color: #235f6e;

    div {
      display: flex;
      flex-direction: row;
      align-items: center;

      width: 100%;
      img {
        margin-left: -30px;
      }
    }
  }

  div.categoria {
    width: 230px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    // border: 1px solid red;
    align-items: center;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.46px;
    color: #235f6e;

    div {
      display: flex;
      flex-direction: row;
      align-items: center;

      width: 100%;
      img {
        margin-left: -30px;
      }
    }
  }

  div.data {
    // border: 1px solid green;
    /* flex: 1; */
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: 0.01px;
    text-align: left;
    color: #235f6e;
    width: 140px;
  }


  div.buttons {
    /* border: 1px solid blue; */
    /* width: 430px; */
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
    button {
      color: #fff;
      border: none;
      display: flex;
      min-width: 140px;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 34px;
      border-radius: 3.5px;
      /* background-color: #74a50a; */
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: normal;
      text-align: right;
      color: #ffffff;
      a {
        color: #fff;
        margin: 0;
        padding: 0;
        display: block;
        padding: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }

      svg,
      img {
        margin-right: 5px;
      }
      &:first-child {
        width: 114px;
        &:hover {
          background-color: ${lighten(0.1, '#74a50a')};
        }
      }
      &:nth-child(2) {
        margin-left: 20px;
        width: 157px;
        background-color: #398ca1;
        &:hover {
          background-color: ${lighten(0.1, '#398ca1')};
        }
      }
      &:last-child {
        width: 77px;
        background-color: #235f6e;

        margin-left: 20px;
        &:hover {
          background-color: ${lighten(0.1, '#235f6e')};
        }
      }
    }
  }
`;

export const BoxPagination = styled.div`
  padding: 40px 30px 30px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    color: #235f6e;
    a {
      color: #235f6e;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;

      svg {
        margin-bottom: -8px;
      }
    }

    a.arrowLeft {
      display: inline-block;
      margin-right: 70px;
    }
    a.arrowRight {
      display: inline-block;
      margin-left: 70px;
    }

    li.ant-pagination-item {
      border: none;
      background-color: transparent;
      width: 26px;
      min-width: 26px;
      height: 26px;
      line-height: 24px;
      a {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        color: #235f6e;
      }
    }
    li.ant-pagination-item-active {
      background-color: #74a50a;
      border-radius: 0;
      a {
        color: #fff;
      }
    }
  }
`;

export const BoxSuporte = styled.div`
  width: 1068px;
  min-height: 200px;
  padding: 50px;
  margin: 20px auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  h2 {
    font-size: 24px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: left;
    font-weight: normal;
    color: #282828;

    span {
      color: #74a50a;
      font-weight: 700;
    }
  }
  div.infoContatos {
    padding-top: 40px;
    span {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: 0.01px;
      text-align: left;
      color: #282828;
      display: block;
      margin-bottom: 5px;
    }
    p {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: 0.01px;
      text-align: left;
      color: #74a50a;
    }
  }
`;
